<template>
  <div id="role-form">
    <div class="row mt-3">
      <div class="col-12">
        <FeaturesPanel :disabled="false" :provider-name="'T'" provider-key="null">
          <h3>{{ $t("hostFeaturesFrom.hostFeaturesManagement") }}</h3>
        </FeaturesPanel>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import FeaturesPanel from "@/core/views/pages/SaaS/_components/FeaturesPanel.vue";
import { eventBus } from "@/main";
import { defineComponent } from "vue";

export default defineComponent({
  name: "HostFeaturesForm",
  components: {
    FeaturesPanel
  },
  created(): void {
    eventBus.emit("pageName", "Host Feature Management");
  }
});
</script>
